import { useEffect, useState } from "react";

const BREAKPOINTS: Record<string, string> = {
  "2xl": "(min-width: 1536px)",
  lg: "(min-width: 1024px)",
  md: "(min-width: 768px)",
  sm: "(min-width: 640px)",
  xl: "(min-width: 1280px)",
};

export function useIsBreakPoint(breakpoint: string): boolean {
  const query = BREAKPOINTS[breakpoint] || breakpoint;
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    const mediaQueryList = window.matchMedia(query);

    const listener = (event: MediaQueryListEvent) => {
      setMatches(event.matches);
    };

    mediaQueryList.addEventListener("change", listener);
    setMatches(mediaQueryList.matches);

    return () => {
      mediaQueryList.removeEventListener("change", listener);
    };
  }, [query]);

  return matches;
}
